import { useTranslation } from 'react-i18next';

import { toDate, useFormatters, type DateInput } from '@/shared/i18n/format';
import { cn } from '@/shared/lib/cn';

import { formatRelative } from './relative';
import { useNow } from './useNow';

export interface RelativeTimeProps {
  date: DateInput;
  className?: string;
}

/** Auto-updating relative timestamp ("5 минут назад") with the full date in the tooltip. Locale-aware. */
export function RelativeTime({ date, className }: RelativeTimeProps) {
  const { t } = useTranslation('shared');
  const fmt = useFormatters();
  const now = useNow();
  const value = toDate(date);
  if (Number.isNaN(value.getTime())) return null;
  return (
    <time
      dateTime={value.toISOString()}
      title={fmt.date(value, 'dateLong') + ', ' + fmt.date(value, 'time')}
      className={cn('tabular-nums', className)}
    >
      {formatRelative(value, now, fmt, t('time.justNow'))}
    </time>
  );
}
